<template>
 <div class="student-machine-ssh">
   <h1>Terminal | </h1>
   <v-divider></v-divider>
   <div id="terminal"></div>
   <v-dialog v-model="loading" persistent fullscreen>
     <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
       <v-layout justify-center align-center>
         <v-progress-circular
           indeterminate
           color="#00aab0"
           :size="100"
           :width="10"
         >
         </v-progress-circular>
       </v-layout>
     </v-container>
   </v-dialog>
   <v-snackbar v-model="snackbar">
     {{ snackbarText }}
     <template v-slot:action="{ attrs }">
       <v-btn text v-bind="attrs" @click="snackbar = false">
         Close
       </v-btn>
     </template>
   </v-snackbar>
 </div>
</template>

<script>
import { Terminal } from 'xterm';
import { FitAddon } from 'xterm-addon-fit';
import { io } from 'socket.io-client';

import StudentService from '@/services/student/student.service';
import AuthService from '@/services/auth/auth.service';

const studentService = new StudentService();
const authService = new AuthService();

export default {
  name: 'StudentMachineSsh',
  data: () => ({
    machine: null,
    terminal: null,
    io: null,
    loading: false,
    snackbar: false,
    snackbarText: '',
  }),
  mounted() {
    this.loading = true;

    const machineId = this.$route.params?.machineId ?? null;

    if (machineId === null) {
      this.$router.push('/');
      return;
    }

    studentService.machine(machineId)
      .then((response) => {
        this.machine = response.data;
        this.startTerminal();
        this.connectSocket();
      })
      .catch((err) => {
        this.loading = false;
        this.showSnack('Falha ao resgatar informações da máquina');
      });
  },
  methods: {
    showSnack(text) {
      this.snackbar = true;
      this.snackbarText = text;
    },
    connectSocket() {
      this.io = new io(process.env.VUE_APP_SOCKET_BASE, {
        auth: {
          token: authService.getToken(),
        },
      });
      this.bindEvents();
    },
    bindEvents() {
      this.io.on('connect', () => {
        this.terminal.write('\r\n*** Connected to socket ***\r\n');
        this.io.emit('machine', this.machine.id)
      });

      this.terminal.onKey((ev) => {
        this.io.emit('input', ev.key);
      });

      this.io.on('ready', () => {
        this.loading = false;
      });

      this.io.on('output', (data) => {
        this.terminal.write(data);
      });

      this.io.on('disconnect', () => {
        this.terminal.write('\r\n*** Disconnected from socket ***\r\n');
      });
    },
    startTerminal() {
      this.terminal = new Terminal();
      const fitAddon = new FitAddon();
      this.terminal.loadAddon(fitAddon);
      const terminalContainer = document.querySelector('#terminal');
      this.terminal.open(terminalContainer);
      fitAddon.fit();
    },
  },
};
</script>

<style scoped>

</style>
